import React, { useState } from 'react';
import {
  Container, Paper, TextField, Button, Typography,
  Box, Link, Alert, CircularProgress, InputAdornment
} from '@mui/material';
import { Email } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { API_BASE_URL } from '@config/api';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event?: React.FormEvent | React.MouseEvent) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!email) {
      setError('Te rog sa introduci adresa de email');
      return;
    }

    setError('');
    setMessage('');
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage('Email-ul de resetare a fost trimis cu succes! Verifica inbox-ul si spam-ul.');
        setEmail('');
      } else {
        setError(data.error || 'Eroare la trimiterea email-ului de resetare');
      }
    } catch (error: any) {
      setError('Eroare de retea. Te rog sa incerci din nou.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <form onSubmit={handleSubmit}>
          <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
            <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
              Health V2
            </Typography>
            <Typography variant="h5" sx={{ mb: 3 }}>
              Resetare Parola
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
              Introdu adresa ta de email si vei primi un link pentru resetarea parolei.
            </Typography>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

            <TextField
              required
              fullWidth
              label="Email"
              type="email"
              margin="normal"
              value={email}
              onChange={e => setEmail(e.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position="start"><Email /></InputAdornment>
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              disabled={isLoading}
            >
              {isLoading ? <CircularProgress size={24} /> : 'Trimite Email de Resetare'}
            </Button>

            <Box sx={{ textAlign: 'center' }}>
              <Link component={RouterLink} to="/login" variant="body2">
                Inapoi la Login
              </Link>
            </Box>
          </Paper>
        </form>
      </Box>
    </Container>
  );
};

export default ForgotPassword; 
